import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, class_type, union_type, lambda_type, unit_type, list_type, tuple_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { SaveStatus, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { SendSMSDTO, SendSMSDTO$reflection } from "./Model.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { append, singleton, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { dotsLoading } from "../../ViewUtils.js";
import { info, error } from "../../Components/Message/Message.js";
import { singleton as singleton_2, cons } from "../../fable_modules/fable-library.3.7.20/List.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { isNullOrWhiteSpace, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ButtonProps, defaultProps } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Containers/SendSMS/View.scss";


export class SendSMSModalProps extends Record {
    constructor(AvailablePhoneNumbers, CloseModalFn, InitialMessage, SendInvoiceViaSMSFn, Header) {
        super();
        this.AvailablePhoneNumbers = AvailablePhoneNumbers;
        this.CloseModalFn = CloseModalFn;
        this.InitialMessage = InitialMessage;
        this.SendInvoiceViaSMSFn = SendInvoiceViaSMSFn;
        this.Header = Header;
    }
}

export function SendSMSModalProps$reflection() {
    return record_type("Containers.SendSMS.View.SendSMSModalProps", [], SendSMSModalProps, () => [["AvailablePhoneNumbers", LoadState$2$reflection(list_type(tuple_type(string_type, string_type)), string_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["InitialMessage", string_type], ["SendInvoiceViaSMSFn", lambda_type(SendSMSDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["Header", string_type]]);
}

export const renderSendSMSModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_8, children_6;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const phoneNumberState = react.useState("");
    const messageState = react.useState(props.InitialMessage);
    const saveState = react.useState(new SaveStatus(0));
    return renderAsModalThenSaveState(true, new ModalSize(1), props.Header, (children_8 = [(children_6 = toList(delay(() => {
        let children, inputRecord, LabelText;
        const matchValue = props.AvailablePhoneNumbers;
        switch (matchValue.tag) {
            case 1: {
                return singleton(dotsLoading);
            }
            case 3: {
                return singleton(error(matchValue.fields[0].split("")));
            }
            case 2: {
                const phoneNumberOptionValues = cons(["", getTranslation("Common.ChooseNumber")], matchValue.fields[0]);
                return append(singleton((children = [selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("CustomerContract.Invoicee.SendSMS.Receiver"), new SelectOption(new ValueProp(0, phoneNumberState[0], (e) => {
                    const arg_2 = Browser_Types_Event__Event_get_Value(e);
                    phoneNumberState[1](arg_2);
                }), "send-sms-message", phoneNumberOptionValues, inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps))))], react.createElement("div", {
                    className: "body__choose-number",
                }, ...children))), delay(() => {
                    let props_3;
                    return append(singleton((props_3 = [new HTMLAttr(65, "body__message"), ["data-translation", "CustomerContract.Invoicee.SendSMS.Message"], new HTMLAttr(161, messageState[0]), new HTMLAttr(115, 320), new DOMAttr(9, (e_1) => {
                        const arg_3 = Browser_Types_Event__Event_get_Value(e_1);
                        messageState[1](arg_3);
                    }), new HTMLAttr(128, getTranslation("CustomerContract.Invoicee.SendSMS.Message"))], react.createElement("textarea", keyValueList(props_3, 1)))), delay(() => {
                        let children_4, arg_4;
                        return singleton((children_4 = [(arg_4 = ((messageState[0]).length | 0), toText(printf("%i/320"))(arg_4))], react.createElement("span", {
                            className: "body__counter",
                        }, ...children_4)));
                    }));
                }));
            }
            default: {
                return singleton(info(getTranslation("Common.WaitingToLoad").split("")));
            }
        }
    })), react.createElement("div", {
        className: "send-sms__body",
    }, ...children_6))], react.createElement("div", {
        className: "send-sms",
        id: "send-sms-modal",
    }, ...children_8)), new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_1) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "cancel-save-sms-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), new ButtonProps(getTranslation("CustomerContract.Invoicee.SendSMS.Send"), defaultProps.Content, (_arg_2) => {
        saveState[1](new SaveStatus(1));
        const dto = new SendSMSDTO(phoneNumberState[0], messageState[0]);
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.SendInvoiceViaSMSFn(dto), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 1) ? (new SaveStatus(3, result.fields[0])) : (new SaveStatus(2));
            saveState[1](arg);
            return singleton_1.Zero();
        })));
    }, isNullOrWhiteSpace(phoneNumberState[0]) ? true : isNullOrWhiteSpace(messageState[0]), "send-sms-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), getTranslation("Common.Close"), (_arg_3) => {
        props.CloseModalFn();
    }, singleton_2([getTranslation("CustomerContract.Invoicee.SendSMS.Sent"), saveState[0]]));
}, void 0, uncurry(2, void 0), void 0, "renderSendSMSModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SendSMS\\View.fs", 106);

